import React, { useContext } from "react";
import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import { useTransition, animated } from "react-spring";
import { MainContext } from "../App.js";

import Config from "../Config/popular.json";

import Procons from "../Assets/procons";

const popular = () => {
  const main = useContext(MainContext);
  const homepage = main.homepage;

  const transitions = useTransition(homepage, null, {
    from: { height: "300px", opacity: "1" },
    enter: { height: "300px", opacity: "1" },
    leave: { height: "0px", opacity: "0" }
  });

  return (
    <>
      <MainContext.Consumer>
        {context =>
          transitions.map(
            ({ item, key, props }) =>
              item && (
                <Container style={{ height: props.height }} key="ccc">
                  <h2>Here are some popular configurations</h2>
                  <SubGrid>
                    {Config.map(aaa => {
                      let color = "black";
                      const toolArray = ["#999999", "#D2091E"];
                      /* eslint-disable-next-line */
                      const Names = ["standard", "impact"];
                      for (const i in toolArray) {
                        if (aaa.Sub[0].type === Names[i]) {
                          color = toolArray[i];
                        }
                      }
                      return (
                        <Link to={`${aaa.Sub[0].link}`} key={aaa.id}>
                          <Card color={color} onClick={context.popularToggle}>
                            <Procons
                              name={aaa.Sub[0].icon}
                              color={aaa.Sub[0].icon}
                            />
                            <span>
                              <h3>{aaa.title}</h3>
                              <p>{aaa.details}</p>
                            </span>
                          </Card>
                        </Link>
                      );
                    })}
                  </SubGrid>
                </Container>
              )
          )
        }
      </MainContext.Consumer>
    </>
  );
};

popular.contextType = MainContext;

export default popular;

const Container = styled(animated.div)`
display: none;
  @supports (display: grid) {
  border-top: 1.5px dotted rgba(0, 0, 0, 0.3);
  overflow: hidden;

    display: flex;

    justify-content: center;
    flex-direction: column;
     grid-column: span 2;
  }

  h2 {
    text-transform: uppercase;
    font-size: 0.9rem;
    font-weight: normal

    text-align: center;

    margin: 0.7rem;
    color: rgba(0, 0, 0, 0.3);
  }
`;

const SubGrid = styled.div`
  @supports (display: grid) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 0.7rem;
    margin: 0.5rem 0;
  }
`;
const opening = keyframes`
from {
    opacity: 0;
    transform: translate3d(2rem,0rem,0);
}
to {
    opacity: .2;
    transform: translate3d(0rem,0rem,0rem);
}
`;
const Card = styled.div`
  align-items: center;

  display: flex;
  padding: 1rem;

  border: 1px solid;
  border-color: ${props => props.color || "rgba(0, 0, 0, 0.2)"};

  position: relative;
  overflow: hidden;

  transition: all 320ms ease-in-out;

  cursor: pointer;
  &::after {
    content: "";
    opacity: 0;
    transform: translate3d(0rem, 2rem, 0rem);
    width: 30%;
    height: 70%;
    background: ${props => props.color || "rgba(0, 0, 0, 0.2)"};
    -webkit-clip-path: polygon(100% 0, 0% 100%, 100% 100%);
    clip-path: polygon(100% 0, 0% 100%, 100% 100%);
    transition: all 320ms ease-in-out;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  &:hover::after {
    transform: translate3d(0, 0, 0);
    opacity: 0.2;
    animation: ${opening} 320ms ease-in-out;
  }

  h3 {
    color: #555555;
    text-transform: uppercase;
    margin: 0;
  }

  p {
    color: #999;
    text-transform: uppercase;
    font-size: 0.5rem;
    font-weight: bold;
    margin: 0;
  }

  svg {
    width: 30%;
    padding: 0;
    margin-right: 1rem;
  }
`;
